import axios from 'axios';
import qs from 'qs';
import { Toast, Dialog } from 'vant';
import router from '@/router/';
import md5 from 'js-md5'
// 配置cookie
import cookie from 'vue-cookies'
import 'vant/lib/index.css';

Toast.setDefaultOptions({ duration: 1500 });

let api_domain = "api.bbs.jx915.cn";
let instance = axios.create({
	timeout: 60000,
  //FIXME 测试
  baseURL: process.env.NODE_ENV === "development" ? '/Api' : '/Api'
});

function getUrlKey(name){
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}

// 渠道
if(localStorage.platform == null || getUrlKey('platform')){
    var platform = getUrlKey('platform');
    if(platform){
        localStorage.setItem('platform',platform);
    }else{
        localStorage.setItem('platform',1);
    }
}

// 游戏id
if(localStorage.game_id == null || getUrlKey('game_id') ){
    var game_id = getUrlKey('game_id');
    if(game_id){
        localStorage.setItem('game_id',game_id);
    }else{
        localStorage.setItem('game_id',1);
    }
}

// 游戏user_name
if(localStorage.user_name == null|| getUrlKey('user_name') ) {
    var user_name = getUrlKey('user_name');
    if(user_name){
        localStorage.setItem('user_name', user_name);
    }
}
// 游戏token
if(localStorage.token == null || getUrlKey('token')) {
    var token = getUrlKey('token');
    if(token){
        localStorage.setItem('token', token);
        cookie.set('PHPSESSID', token);
    }
}
// 时间戳
var time = new Date().getTime();
// 签名后端大神参数
var appkey = md5('Z8ECEhuPiDMKl'+localStorage.game_id+'oPecRCknm30'+time);

instance.interceptors.request.use( (config) => {

  // !config.hideLoading && Toast.loading({overlay: true, duration: 0});

    // if(token){
    //     cookie.set('PHPSESSID', token);
    // }

    // cookie.set('PHPSESSID', localStorage.token);

    // 图片上传的时候参数由formdata添加，其他时候默认添加
    if(config.myprop != 'upImg'){

        Object.assign(config.data,{ time:time,game_id:localStorage.game_id ,sign:appkey});

        if (config.method === 'post' || config.method === 'put') {
            config.data = qs.stringify(config.data);
        }
    }



	return config;
}, (err) => {
	return Promise.reject(err);
});

instance.interceptors.response.use( (res) => {
  Toast.clear();
    if(res.data.ret == -1){
        Toast.fail(res.data.msg);
    };
    return res;
}, (error) => {
    Toast.clear();
    if (error && error.response) {
      switch (error.response.ret) {
        case 400:
          let msg = error.response.data.msg;
          let code = error.response.data.code;
          if(code !== 200){
            Dialog.alert({
              title: "提示",
              message: `系统错误`
            })
          }else{
            Toast.fail(msg);
          }
          if(error.response.data.code === 10001){
            setTimeout(() => {
              localStorage.removeItem('token')
              router.push({path: 'login'});
            }, 500)
          }
          break;
        case 500:
          Toast.fail('抱歉，服务端异常');
          break;
        default:
          Toast.fail('未知错误！！');
          break;
      }
    }
    return Promise.reject(error);
});

const post = (url, data, config = {}) => {
	return instance.post(url, data, config)
}

const put = (url, data, config = {}) => {
	return instance.put(url, data, config)
}

const get = (url, params, config = {}) => {
	return instance.get(url, {
		params: params,
		...config
	})
}

const deleteMethod = (url, config = {}) => {
	return instance({
		url: url,
		method: 'delete',
		...config
	})
}

export default {
	install(Vue) {
		Object.defineProperties(Vue.prototype, {
			$reqGet: {
				value: get
			},
			$reqPost: {
				value: post
			},
			$reqPut: {
				value: put
			},
			$reqDel: {
				value: deleteMethod
			},
		})
	}
}



// WEBPACK FOOTER //
// ./src/plugins/axios.js